import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Per-route <title> and meta description updater.
// Runs on every route change so Google + browser tabs stay accurate.
const ROUTE_META = {
  "/": {
    title: "Out Of Touch — Toronto's Live Hall & Oates Tribute Band",
    description:
      "Out Of Touch is Toronto's premier live tribute to the music of Hall & Oates. Hear Maneater, Kiss on My List, Private Eyes, She's Gone and more — performed live.",
  },
  "/band": {
    title: "Meet the Band — Out Of Touch | Hall & Oates Tribute",
    description:
      "Meet the musicians behind Out Of Touch — a Toronto-based Hall & Oates tribute band featuring seasoned players from Classic Albums Live and beyond.",
  },
  "/music": {
    title: "Hear the Band — Out Of Touch | Hall & Oates Live Tribute",
    description:
      "Listen to live samples from Out Of Touch — Toronto's Hall & Oates tribute band. Maneater, Kiss on My List, Private Eyes, and She's Gone.",
  },
  "/book": {
    title: "Book Out Of Touch — Hall & Oates Tribute Band | Toronto",
    description:
      "Book Out Of Touch for your event, corporate function, festival, or private show. Toronto's live Hall & Oates tribute band — inquire for dates and rates.",
  },
};

const DEFAULT = ROUTE_META["/"];

function setMeta(name, content, attr = "name") {
  if (typeof document === "undefined") return;
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  if (typeof document === "undefined") return;
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
}

export default function SEO() {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = ROUTE_META[pathname] || DEFAULT;
    document.title = meta.title;
    setMeta("description", meta.description);
    setMeta("og:title", meta.title, "property");
    setMeta("og:description", meta.description, "property");
    setMeta("og:url", `https://outoftouch.live${pathname}`, "property");
    setMeta("twitter:title", meta.title);
    setMeta("twitter:description", meta.description);
    setCanonical(`https://outoftouch.live${pathname}`);
  }, [pathname]);

  return null;
}
